module.exports = __webpack_public_path__ + "technology.2kPR-OSN.svg";